import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_115: FaireProductEntity = {
  token: "catalog_prod_prod-115",
  type: "product",
  name: "Tree Skirt - Embroidered Santa's Sleigh (Pk/02)",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 28.29,
  msrpDollars: 70.72,
  sku: "VI0115",
  caseSize: 12,
  material: "Glass",
  collectionToken: "col_vintage-holiday",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 21,
  description: "Beautiful Vintage Holiday piece perfect for any home.",
  categoryTokens: ["catalog_cat_jewelry-storage"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
